export const TOP_NAV_CONTENTS = {
    PRODUCTION: 'Production',
    SCHEDULING: 'Scheduling',
    QUALITY: 'Quality',
    MFG_PARTNERS: 'Manufacturing Partners',
}

export const ASSIGNED_TO_SO = 'SO'
export const ASSIGNED_TO_WO = 'WO'
export const NOT_AVAILABLE = 'NA'
export const FORBIDDEN_MESSAGE = 'Permission denied'
export const PRECONDITION_FAILED = 'Precondition Failed'
export const MAX_SHIP_TO_LENGHTH = 57
export const PAYMENT_TYPE = 'cc'
export const ASSIGNED_TO_JOB = 'JOB'

export const SHIPPING_METHOD_DISPLAY_NAMES = {
    overnight: 'One day',
    one_day: 'One day',
    ground: 'Standard',
    overseas_1_day: 'International priority',
    overseas_economy: 'International economy',
    standard: 'Standard',
    no_shipping: 'No Shipping',
    freight_forwarder: 'Freight Forwarder',
}

export const TABLE_NAMES = [
    'SCHEDULING_JOB_LINES_TABLE',
    'MP_JOBS_LIST_TABLE',
    'MP_FAILURE_LIST_TABLE',
    'PRODUCTION_CAR_LIST_TABLE',
    'UNBUNDLEED_SALES_ORDERS_TABLE',
    'SCHEDULING_JOBS_TABLE',
    'SALES_ORDER_DETAILS_ORDER_LINES_TABLE',
    'SALES_ORDER_DETAILS_PROCESS_LINES_TABLE',
    'QUALITY_JOB_REQUEST_LIST_TABLE',
    'PROD_WB_SALE_ORDER_TABLE',
    'PROD_WB_JOB_REQUEST_TABLE',
    'PROD_WB_EXCEPTIONS_TABLE',
    'PROD_WB_JOBS_TABLE',
] as const

export const MILESTONE_DISPLAY_NAME = {
    scheduling: 'Schedule MP by',
    production: 'Fictiv dock date',
    inspection: 'Fictiv QC by',
    delivery_order: 'Shipment release by',
    shipping: 'Carrier pickup by',
    customer_delivery: 'Customer delivery date',
}

export const OPS_WB_TABLES = {
    schedulingJobLines: TABLE_NAMES[0],
    mpJobsList: TABLE_NAMES[1],
    mpFailureList: TABLE_NAMES[2],
    productionCarList: TABLE_NAMES[3],
    unbundledSalesOrdersTable: TABLE_NAMES[4],
    schedulingJobsTable: TABLE_NAMES[5],
    salesOrderDetailsOrderLines: TABLE_NAMES[6],
    salesOrderDetailsProcessLines: TABLE_NAMES[7],
    qualityJobRequestList: TABLE_NAMES[8],
    prodWbSalesOrderList: TABLE_NAMES[9],
    prodWbJobRequestList: TABLE_NAMES[10],
    prodWbExceptionList: TABLE_NAMES[11],
    prodWbJobsTable: TABLE_NAMES[12],
}

export const CARS_TYPE = Object.freeze({
    MP: 'mp',
    FICTIV: 'fictiv',
})

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT_WITH_TZ = 'YYYY-MM-DD, HH:mm z'
export const DATE_TIME_FORMAT_WITHOUT_TZ = 'YYYY-MM-DD, HH:mm'
export const TIME_FORMAT_HOURS_MIN = 'HH:mm'
export const MONTH_FIRST_DATE_FORMAT = 'MM/DD/YYYY'
export const MODAL_TYPES = {
    BUNDLE_PARTS: 'bundleParts',
    FORBIDDEN: 'forbidden',
} as const

export const TAG_COLORS = {
    RED: 'red',
    ORANGE: 'orange',
    GREEN: 'green',
    BLUE: 'blue',
    GRAY2: 'gray2',
}

export const JOB_HISTORY_MESSAGE_TYPES = {
    FILTER: 'Filter:',
    PAYOUT_MODIFIERS: 'Payout Modifiers:',
}

export const DEFAULT_BUSINESS_UNIT = 'Unassigned'
